"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var getColor = function getColor(isActive, isMouseOver) {
  if (isActive) {
    return "text-light-grey";
  }

  if (isMouseOver) {
    return "text-title";
  }

  return "body-grey";
};

var itemFontObject = {
  fontSize: 1,
  fontWeight: 1,
  letterSpacing: "0.5px",
  lineHeight: 2
};

var ListItem = function ListItem(_ref) {
  var ActiveGlyph = _ref.activeGlyph,
      isActive = _ref.isActive,
      isMouseOver = _ref.isMouseOver,
      item = _ref.item;
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "center",
    justifyContent: "space-between",
    px: 3,
    py: 12
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    as: "div",
    color: getColor(isActive, isMouseOver)
  }, itemFontObject), item.label), isActive && ActiveGlyph && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    display: "inline-flex",
    ml: 4
  }, /*#__PURE__*/_react["default"].createElement(ActiveGlyph, {
    fill: "black",
    height: 14,
    width: 14
  })));
};

ListItem.propTypes = {
  activeGlyph: (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.object, _propTypes.node]),
  isActive: _propTypes.bool,
  isMouseOver: _propTypes.bool,
  item: (0, _propTypes.shape)({
    id: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    label: _propTypes.string,
    value: _propTypes.string
  })
};
ListItem.displayName = "Modules.ListItem";
var _default = ListItem;
exports["default"] = _default;